import { currentUserService } from "../services/currentUser.service";
import { userConstants, userNameSpace, permissionConstants, permissionsNameSpace, statusNameSpace, statusConstants } from "../constants/currentUser.constants";

export const getCurrentUser = () => {
    return async (dispatch) => {
        dispatch(request());
        try {
            const response = await currentUserService.getCurrentUser();
            if (response) {
                dispatch(success(response));
                dispatch(getCurrentStatus({ username: response.email }));
            }
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function request() {
        return { type: userConstants[`GET_${userNameSpace}_REQUEST`] };
    }
    function success(response) {
        return { type: userConstants[`GET_${userNameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: userConstants[`GET_${userNameSpace}_FAILURE`], error };
    }
};
export const getCurrentStatus = (userName) => {
    return async (dispatch) => {
        dispatch(request());
        try {
            const response = await currentUserService.getCurrentUserStatus(userName);
            if (response) {
                dispatch(success(response));
            }
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function request() {
        return { type: statusConstants[`GET_${statusNameSpace}_REQUEST`] };
    }
    function success(response) {
        return { type: statusConstants[`GET_${statusNameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: statusConstants[`GET_${statusNameSpace}_FAILURE`], error };
    }
};

export const getPermissions = () => {
    return async (dispatch) => {
        dispatch(request());
        try {
            const response = await currentUserService.getPermissions();
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function request() {
        return { type: permissionConstants[`GET_${permissionsNameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: permissionConstants[`GET_${permissionsNameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return {
            type: permissionConstants[`GET_${permissionsNameSpace}_FAILURE`],
            error,
        };
    }
};

// export const resetCurrentUser = () => {
//   return { type: userConstants[`POST_${nameSpace}_RESET`] };
// };
